import { createUseStyles } from 'react-jss';

export const storiesContainer = {
  maxWidth: 400,
  marginLeft: 20,
};

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    container: {
      width: 0,
      flex: 1,
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    leftArrowContainer: {
      background: 'var(--x-bg-section-card-opacity)',
      position: 'absolute',
      left: 0,
      height: '100%',
      zIndex: 101,
      display: 'none',
    },
    leftArrow: {
      margin: 'auto',
      fill: '#000',
    },
    rightArrowContainer: {
      position: 'absolute',
      right: 0,
      zIndex: 101,
      display: 'none',
      height: '100%',
    },
    rightArrow: {
      margin: 'auto',
      fill: '#000',
    },
    block: {
      display: 'block',
    },
  },
  { name: 'with-scrollbar-arrrows' },
);

export default useStyles;
